module.exports = __webpack_public_path__ + "static/media/plane.e54713d0.svg";